import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const API  = axios.create({ baseURL: BASE, timeout: 120000 });

// Inject JWT token
API.interceptors.request.use(cfg => {
  const token = localStorage.getItem('dl_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// ── Blog API ────────────────────────────────────────────────────────
export const blogAPI = {
  getAll:        p  => API.get('/blogs', { params: p }),
  getLatest:     ()  => API.get('/blogs/latest'),
  getBySlug:     s  => API.get(`/blogs/${s}`),
  adminAll:      ()  => API.get('/blogs/admin/all'),
  create:        d  => API.post('/blogs', d),
  update:    (id,d)  => API.put(`/blogs/${id}`, d),
  remove:       id  => API.delete(`/blogs/${id}`),
};

// ── Auth API ────────────────────────────────────────────────────────
export const authAPI = {
  login:  d => API.post('/auth/login', d),
  verify: () => API.get('/auth/verify'),
  setup:  () => API.post('/auth/setup'),
};

// ── Tool API ────────────────────────────────────────────────────────
const blobPost = (url, fd) =>
  API.post(url, fd, {
    responseType: 'blob',
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const toolAPI = {
  // PDF
  imageToPDF:  fd => blobPost('/tools/pdf/image-to-pdf', fd),
  pdfToWord:   fd => blobPost('/tools/pdf/to-word', fd),
  compressPDF: fd => blobPost('/tools/pdf/compress', fd),
  mergePDFs:   fd => blobPost('/tools/pdf/merge', fd),
  splitPDF:    fd => blobPost('/tools/pdf/split', fd),
  pdfToZip:    fd => blobPost('/tools/pdf/to-zip', fd),
  // Image
  jpgToPng:    fd => blobPost('/tools/image/jpg-to-png', fd),
  resizeImage: fd => blobPost('/tools/image/resize', fd),
  compressImg: fd => blobPost('/tools/image/compress', fd),
  removeBg:    fd => blobPost('/tools/image/remove-bg', fd),
  // Text
  wordCount: text => API.post('/tools/text/word-count', { text }),
};

// ── YouTube API ─────────────────────────────────────────────────────
export const youtubeAPI = {
  // Get video info (title, thumbnail, duration)
  getInfo: url => API.post('/youtube/info', { url }),
  // Direct MP3 download — returns blob stream from server
  downloadMp3: videoId =>
    API.post('/youtube/download', { videoId }, {
      responseType: 'blob',
      timeout: 180000, // 3 minutes for long videos
    }),
};

// ── Helpers ─────────────────────────────────────────────────────────
export const mkUrl  = blob => URL.createObjectURL(blob);

export default API;
